var symphony = symphony || {};

;
(function () {

	symphony.getWordpressStories = function () {

		var impactContainer = $('.impactStories');

		if (window.localStorage && localStorage.getItem('impactStoryGrid') !== null) {

			symphony.stories = JSON.parse(localStorage.getItem('impactStoryGrid'));

			impactContainer.empty().append(symphony.templates.impactStories({
				story: symphony.stories
			}));

			createSlider();

		} else {

			var data = {
				per_page: 8
			};
			if (wpApiTagIds && wpApiTagIds.length > 0) {
				data['tags'] = wpApiTagIds;
			}
			var promise = $.get(wpApiEndpoint + '/posts', data);

			promise.done(function (data) {

				symphony.stories = data;

				// Additional call to get the Featured Image for each post
				$.each(symphony.stories, function (i, story) {
					var featuredImage = $.get(wpApiEndpoint + '/media/' + story.featured_media);
					featuredImage.done(function (data) {

						symphony.stories[i].media = data;

						// Store the results to localStorage for faster retrieval
						localStorage.setItem('impactStoryGrid', JSON.stringify(symphony.stories));

						impactContainer.empty().append(symphony.templates.impactStories({
							story: symphony.stories
						}));

						createSlider();

					});
				});

			});
		}

		function createSlider() {
			var windowWidth = $(window).outerWidth();

			if (windowWidth > 464) {
				$('.impactStories-slider').slick({
					infinite: true,
					slidesToShow: 3,
					slidesToScroll: 1
				});
			} else {
				$('.impactStories-slider').slick({
					infinite: true,
					slidesToShow: 2,
					slidesToScroll: 1
				});
			}

		}



	};


})();
